import { Injectable, Inject, EnvironmentInjector } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { FundsPortalService, HttpRequestService } from '../core.module';
import { LocalStorageService } from '../core.module';
import { Router } from '@angular/router';

@Injectable({
    providedIn: 'root'
  })
  export class AuthService extends HttpRequestService<any>{

    private clearTimeout: any;

    constructor(
        httpClient: HttpClient,
        private localStorageService: LocalStorageService,
        private fundsPortalService: FundsPortalService,
        private router: Router) {
        super(httpClient);
      }

    public postLogin(body: {}) {
        const httpHeaders: HttpHeaders = new HttpHeaders()
        
        return this.post(`login`, body, undefined, httpHeaders)
        .pipe(
            map((data: any) => data),
            catchError(this.handleError));
    }

    public postValidateLogin(body: {}) {
        const httpHeaders: HttpHeaders = new HttpHeaders()
        .set('Authorization', `Bearer ${this.localStorageService.get('bearer') || ''}`);

        return this.post(`login_verification_mobile_no`, body, undefined, httpHeaders)
        .pipe(
            map((data: any) => data),
            catchError(this.handleError));
    }

    public postResendLoginOTP() {
        const httpHeaders: HttpHeaders = new HttpHeaders()
        .set('Authorization', `Bearer ${this.localStorageService.get('bearer') || ''}`);

        return this.post(`resend_login_verification_mobile_no`, undefined, undefined, httpHeaders)
        .pipe(
            map((data: any) => data),
            catchError(this.handleError));
    }

    public autoLogOut(){  
      const expiry = Math.abs((Date.now() - parseInt(this.localStorageService.get('bearer_expiry') || '')));
      this.clearTimeout = setTimeout(() => {
        this.logOut();
      }, expiry);
    }

    public logOut(){
      localStorage.clear();
      this.router.navigateByUrl(``, { skipLocationChange: false });
      if(this.clearTimeout){
        clearTimeout(this.clearTimeout);
      }
    }

    public refreshToken(){
      if(this.localStorageService.get('bearer') === null || this.localStorageService.isExpired('bearer')){
        localStorage.clear();
        this.router.navigateByUrl(``, { skipLocationChange: false });
      }
      return new Promise((resolve, reject) => {
        this.fundsPortalService.postRefreshToken().subscribe({
          next: (data:any) =>{
            resolve(data);
            this.localStorageService.remove('bearer');
            this.localStorageService.set('bearer', data['response_data']['access_token'],data['response_data']['expires_in']);
            if(this.clearTimeout){
              clearTimeout(this.clearTimeout);
            }
            this.autoLogOut();
          },
          error: error =>{
  
            }
        })
      });
    }

    private handleError(error: HttpErrorResponse) {
        if (error.status === 0) {
          // A client-side or network error occurred. Handle it accordingly.
          console.error('An error occurred:', error.error);
        } else {
          // The backend returned an unsuccessful response code.
          // The response body may contain clues as to what went wrong.
          console.error(
            `Backend returned code ${error.status}, body was: `, error.error);
        }
        // Return an observable with a user-facing error message.
        return throwError(() => error.error);
    }

}